import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  Button,
} from '@mui/material';
import React from 'react';
import {useSnackbar} from 'notistack';
import {useAddCompanyTypeMutation, useGetCompanyTypesQuery} from 'api';
import CompanyTypeForm from './CompanyTypeForm';

function CreateCompanyTypeModal({open, onClose}) {
  const {isLoading, isError} = useGetCompanyTypesQuery();
  const formRef = React.useRef();
  const [addCompanyType] = useAddCompanyTypeMutation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const {enqueueSnackbar} = useSnackbar();
  return (
    <Dialog fullWidth scroll="body" maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle mb={2} variant="h6">
        Create CompanyType
      </DialogTitle>
      <DialogContent>
        <CompanyTypeForm
          disabled={isLoading || isError}
          ref={formRef}
          onSubmit={async (values, actions) => {
            try {
              setIsSubmitting(true);
              const newObj = {
                ...values,
              };
              await addCompanyType(newObj).unwrap();
              actions.resetForm();
              enqueueSnackbar('CompanyType created successfully', {
                variant: 'success',
              });
              onClose();
            } catch (e) {
              const message =
                e.status === 400 ? e.companyTypeResponse?.details?.[0]?.message : undefined;
              enqueueSnackbar(message || 'Failed to create CompanyType', {
                variant: 'error',
              });
            } finally {
              setIsSubmitting(false);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={isSubmitting} color="inherit" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          endIcon={isSubmitting ? <CircularProgress ml={2} size={16} /> : null}
          disabled={isSubmitting}
          color="primary"
          variant="contained"
          onClick={() => formRef.current?.submit?.()}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateCompanyTypeModal;
